import { useCallback, useEffect, useState } from "react";
import { getResearchJobs, getResearchJob } from "@/lib/api";

export const useResearchJobs = (kind) => {
  const [jobs, setJobs] = useState([]);
  const [job, setJob] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    try {
      const rows = await getResearchJobs(kind);
      setJobs(rows);
      setJob((previous) => previous || rows[0] || null);
      setError("");
    } catch (e) { setError(e.response?.data?.detail || "İnceleme geçmişi alınamadı."); }
    finally { setLoading(false); }
  }, [kind]);
  useEffect(() => { load(); }, [load]);
  const running = job && ["queued", "running"].includes(job.status);
  useEffect(() => {
    if (!running) return;
    let alive = true;
    const poll = async () => {
      try {
        const result = await getResearchJob(job.id);
        if (alive) {
          setJob(result);
          setJobs((rows) => rows.map((r) => r.id === result.id ? result : r));
          setError("");
        }
      } catch (e) { if (alive) setError(e.response?.data?.detail || "İlerleme okunamadı; tekrar deneniyor."); }
    };
    const timer = setInterval(poll, 1500);
    return () => { alive = false; clearInterval(timer); };
  }, [running, job?.id]);
  const created = (row) => { setJobs((rows) => [row, ...rows.filter((r) => r.id !== row.id)]); setJob(row); setError(""); };
  return { jobs, job, setJob, error, setError, loading, running, created };
};